// Вход через провайдера OIDC (Skillspace ID). Браузер уходит на
// /auth/oidc/start, провайдер возвращает его на сервер, сервер — обратно сюда с
// одноразовым билетом во фрагменте адреса (#oidc-ticket=…), который
// приложение меняет на сессию.

const ticketKey = "oidc-ticket";
const loginErrorKey = "login_error";
const knownErrors = new Set([
  "cancelled",
  "expired",
  "invitation_invalid",
  "invitation_mismatch",
  "link_conflict",
  "no_email",
  "provider",
  "service_account",
  "unverified_email",
]);

// Куда вернуться после входа — туда, где человек был (например, на экран
// подключения агента), без следов прошлой неудачной попытки.
export function oidcStartUrl(input: { invitationToken?: string; locale: string; location: Pick<Location, "pathname" | "search"> }): string {
  const search = new URLSearchParams(input.location.search);
  search.delete(loginErrorKey);
  const query = search.toString();
  const params = new URLSearchParams({ locale: input.locale, return: `${input.location.pathname}${query ? `?${query}` : ""}` });
  if (input.invitationToken) params.set("invitation", input.invitationToken);
  return `/auth/oidc/start?${params.toString()}`;
}

export function readOidcTicket(hash: string): string | null {
  const ticket = new URLSearchParams(hash.replace(/^#/, "")).get(ticketKey);
  return ticket && ticket.length >= 20 && ticket.length <= 200 ? ticket : null;
}

export function readLoginError(search: string): string | null {
  const code = new URLSearchParams(search).get(loginErrorKey);
  return code && knownErrors.has(code) ? code : null;
}

// Билет → сессия. Кука браузера, начавшего вход, уходит с запросом сама
// (путь /auth/oidc): без неё сервер билет не примет.
export async function redeemOidcTicket(ticket: string): Promise<string> {
  const response = await fetch("/auth/oidc/redeem", {
    body: JSON.stringify({ ticket }),
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    method: "POST",
  });
  const body = (await response.json().catch(() => null)) as { sessionToken?: unknown } | null;
  if (!response.ok || typeof body?.sessionToken !== "string") throw new Error("Sign-in ticket was not accepted");
  return body.sessionToken;
}
